import { render, staticRenderFns } from "./gg-country-language-table.vue?vue&type=template&id=5e186a30&"
import script from "./gg-country-language-table.vue?vue&type=script&lang=js&"
export * from "./gg-country-language-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports